import {
  CurrencyService,
  DataService,
  I18nService,
  LocaleCurrencyPipe,
  SharedModule,
  CurrencyCode,
} from "@bb-vendure/admin-ui/core";
import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { take } from "rxjs";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";

export type refundLineType = {
  orderLineId: string;
  quantity: number;
};
@Component({
  selector: "order-detail-table",
  standalone: true,
  templateUrl: "./order-detail-table.component.html",
  styleUrls: ["./order-detail-table.component.scss"],
  imports: [SharedModule],
})
export default class OrderDetailTableComponent implements OnInit {
  @Input() refundLines: refundLineType[];
  @Input() lines: any[];
  @Input() index: number;
  @Input() currencyCode: string;
  @Output() closeEvent = new EventEmitter();

  refundLinesResult: any[] = [];

  constructor(
    protected translateService: I18nService,
    private currencyService: CurrencyService,
    protected dataService: DataService
  ) {}

  ngOnInit() {
    // Get refund lines from lines by orderLineId using filter and map
    this.refundLinesResult = this.lines
      .filter((line) => {
        return this.refundLines.some(
          (refundLine) => refundLine.orderLineId === line.orderLine.id
        );
      })
      .map((line) => {
        const refundLine = this.refundLines.find(
          (refundLine) => refundLine.orderLineId === line.orderLine.id
        );
        return {
          ...line,
          quantity: refundLine!.quantity,
          total: line.unitPriceWithTax * refundLine!.quantity,
        };
      });
  }

  convertPrice(total: any) {
    const pipe = new LocaleCurrencyPipe(this.currencyService, this.dataService);
    const result = pipe.transform(total, this.currencyCode) as string;
    if (this.currencyCode === CurrencyCode.KRW) {
      return result.split(".")[0];
    }
    return result;
  }

  close() {
    this.closeEvent.emit();
  }
}
